<ion-modal [isOpen]="isOpen" (didDismiss)="onCancel()" class="logout-confirm-modal">
  <ng-template>
    <div class="logout-modal-content">
      <!-- Top Close Button -->
      <div class="modal-close" (click)="onCancel()">
        <ion-icon name="close-outline"></ion-icon>
      </div>

      <div class="modal-body">
        <!-- Illustrative Logout Icon -->
        <div class="logout-icon-wrapper">
          <div class="icon-circle">
            <ion-icon name="log-out-outline"></ion-icon>
          </div>
        </div>

        <!-- Text Content -->
        <div class="text-content">
          <h2 class="modal-title">Confirm Logout</h2>
          <p class="modal-message">
            Are you sure you want to log out? You will need to log in again to access your account and legal documents.
          </p>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <ion-button expand="block" class="logout-confirm-btn" (click)="onConfirm()">
            Yes, Log Out
          </ion-button>
          
          <button class="cancel-text-btn" (click)="onCancel()">
            Keep Me Logged In
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
